import { useState, useEffect } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";

import useAxios from "../services/useAxios";

import SingleProduct from "../components/single-product-page";

import "../components/single-product-page/single-product-page-style.scss";
export default function SingleProductPage() {
  const { productId } = useParams();
  const rout = useLocation();
  const navigate = useNavigate();

  const { execute: getProduct } = useAxios("product/get_products");

  const [addOrEdit, setAddOrEdit] = useState("add");
  const [productData, setProductData] = useState({});
  const [productListUpdater, setProductListUpdater] = useState(false);

  useEffect(() => {
    let productIdTrue = /\d/.test(productId);
    if (productIdTrue) {
      setAddOrEdit("edit");
      getProduct({ product_id: productId }).then((result) => {
        setProductData(result.result[0] ?? {});
      });
    } else if (
      !productIdTrue &&
      rout?.pathname != "/new-single-product/create"
    ) {
      navigate("/new-product-list");
    }
  }, [productId, productListUpdater]);

  return (
    <div className="single-product-page">
      <SingleProduct
        addOrEdit={addOrEdit}
        productData={productData}
        setProductListUpdater={setProductListUpdater}
      />
    </div>
  );
}
